import React, { useState, useEffect, useRef } from 'react';
import { Checkbox, Dimmer, Form, Input, Loader, Visibility, Button } from 'semantic-ui-react';

import { useSelector, useDispatch } from 'react-redux';
import { clearLookup, getLookupRequest, listSelector, progressSelector } from '../../ducks/lookup';
import { PAGE_SIZE } from '../../constants/settings';
import Search from '../Search';

const Facet = ({t, source, name, onChange, value, gridName, filters = {}}) => {
    const dispatch = useDispatch();

    let [filter, setFilter] = useState(null);
    let [items, setItems] = useState([]);
    let [counter, setCounter] = useState(PAGE_SIZE);
    let [ filterValues, setFilterValues ] = useState([]);

    const valuesList = useSelector(state => listSelector(state, filter, t));
    const loading = useSelector(state => progressSelector(state));

    const context = useRef(null);

    const inputRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            inputRef && inputRef.current && inputRef.current.focus();
        }, 500)
    }, []);

    useEffect(() => {
        handleOpen();
        return clearFilter;
    }, []);

    useEffect(
        () => {
            changeItems();
        },
        [valuesList, counter],
    );

    useEffect(
        () => {
            context.current.scrollTop = 0;
            setCounter(PAGE_SIZE);
        },
        [filter],
    );

    useEffect(
        () => {
            value && setFilterValues(value);
        },
        [value],
    )

    const changeItems = () => {
        setItems(valuesList.slice(0, counter));
    };

    const handleSetFilter = (e, { value }) => {
        setFilter(value);
    };

    const clearFilter = () => {
        setFilter(null);
        setFilterValues([]);
        dispatch(clearLookup());
    };

    const handleOpen = () => {
        dispatch(
            getLookupRequest({
                name,
                entities: gridName,
                isFilter: true,
                params: filters.filter,
            }),
        );
    };

    const handleRestClick = () => {
        setFilterValues([]);
        if (onChange !== undefined) onChange(null, { name: name, value: null });
    };

    const toggle = (e, { value }) => {
        let values = filterValues && filterValues.length !== 0 ? filterValues.split('|') : [];
        if (values.some(x => x === value)) {
            values.splice(values.indexOf(value), 1);
        } else {
            values.push(value);
        }

        setFilterValues(values.join('|'));

    };

    const handleApplyFilter = (e) => {
        if (onChange !== undefined && filterValues && filterValues.length !== 0) onChange(e, { name: name, value: filterValues });
    }

    const scroll = () => {
        if (counter < valuesList.length) {
            setCounter(prevState => prevState + PAGE_SIZE);
        }
    };


    return (
        <div className="facet-input">
            <Form>
                {/*<label className="label-in-popup">{t(name)}</label>*/}
                <div>
                    <Search
                        ref={inputRef}
                        fluid
                        size="mini"
                        placeholder=""
                        isAuto
                        onChange={handleSetFilter}
                    />
                    {/* <Input
                        fluid
                        size="mini"
                        icon="search"
                        value={filter}
                        onChange={handleSetFilter}
                    />*/}
                </div>
                <Button style={{marginTop: "10px",width: "100%"}} onClick={handleApplyFilter}>{t("apply_filter_btn")}</Button>
                <div className="reset-selected">
                    <span onClick={handleRestClick}>{t('reset_selected')}</span>
                </div>
                <div className="select-facet-values" ref={context}>
                    <Dimmer active={loading} inverted>
                        <Loader size="small">Loading</Loader>
                    </Dimmer>
                    <div style={{ position: 'relative' }}>
                        {items &&
                            items.map(x => {
                                let label = <label>{x.name}</label>;
                                return (
                                    <Form.Field
                                        key={x.value}
                                        className={!x.isActive ? 'colorGrey' : ''}
                                    >
                                        <Checkbox
                                            value={x.value}
                                            checked={filterValues && filterValues.length !== 0 && filterValues.split('|') .includes(x.value)}
                                            onChange={toggle}
                                            label={label}
                                        />
                                    </Form.Field>
                                );
                            })}
                        <Visibility
                            continuous={true}
                            once={false}
                            context={context.current}
                            onTopVisible={scroll}
                            style={{
                                position: 'absolute',
                                bottom: '20px',
                                left: 0,
                                right: 0,
                                zIndex: -1,
                            }}
                        />
                    </div>
                </div>
            </Form>
        </div>
    );
};

export default Facet;
